import WhatsappIcon from '../../../img/messengers/whatsapp-rounded.svg';
import TelegramIcon from '../../../img/messengers/telegram-rounded.svg';
import ViberIcon from '../../../img/messengers/viber-rounded.svg';
import MessengerIcon from '../../../img/messengers/messenger-rounded.svg';
import VkIcon from '../../../img/messengers/vk-rounded.svg';
import SkypeIcon from '../../../img/messengers/skype-rounded.svg';

export default [
    {
        messenger: 'whatsapp',
        name: 'WhatsApp',
        icon: WhatsappIcon,
    },
    {
        messenger: 'telegram',
        name: 'Telegram',
        icon: TelegramIcon,
    },
    {
        messenger: 'viber',
        name: 'Viber',
        icon: ViberIcon,
    },
    {
        messenger: 'messenger',
        name: 'Facebook Messenger',
        icon: MessengerIcon,
    },
    {
        messenger: 'vk',
        name: 'Vkontakte',
        icon: VkIcon,
    },
    {
        messenger: 'skype',
        name: 'Skype',
        icon: SkypeIcon,
    },
];
